import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import type { FormCheckboxControl } from '@angular/forms/signals';
import { UiFieldControl } from '../../../basics/ui-field-control';
import { getRandomId } from '../../../utils/get-random-id';
import { IconUIComponent } from '../icon/icon.component';

@Component({
  selector: 'fr8bot-ui-checkbox-field',
  imports: [IconUIComponent],
  templateUrl: './checkbox-field.component.html',
  styleUrl: './checkbox-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxFieldComponent extends UiFieldControl implements FormCheckboxControl {
  readonly checked = model(false);

  protected readonly id = getRandomId('checkbox');

  protected onChange(element: HTMLInputElement): void {
    this.checked.set(element.checked);
    this.touch.emit();
  }
}
